const orAst = (values, col = 0) => ({ type: "or", value: values, col });
const andAst = (values, col = 0) => ({ type: "and", value: values, col });
const cmpAst = (key, op, value, col = 0) => ({ type: "cmp", key, op, value, col });
const valueAst = (value, col = 0) => ({ type: "value", value, col });
export {
  andAst,
  cmpAst,
  orAst,
  valueAst
};
//# sourceMappingURL=ast-factories.js.map
